import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { EmployeeListPage } from '@/features/employees'

export const Route = createFileRoute('/_authenticated/employees')({
  component: () => (
    <RequirePermission permission='employees.read'>
      <EmployeeListPage />
    </RequirePermission>
  ),
})
